const Images = {
  futurisingIcon: require("./icon.svg").default,
  futurisingIogo: require("./logo.svg").default,
  futurisingIconSquare: require("./futurisingIconSquare.png"),
};

export default Images;
